/**
 * Application developer attribution.
 * Visible credit is a small English line.
 */
export const DEVELOPER_NAME =
  process.env.REACT_APP_DEVELOPER_NAME || "هشام محمد الاختيار";

export const DEVELOPER_NAME_EN =
  process.env.REACT_APP_DEVELOPER_NAME_EN || "Hesham Mohamed Al-Ekhtiar";

export const DEVELOPER_CREDIT = `Developed by ${DEVELOPER_NAME_EN}`;
